
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

export type ListWarn<T> = {
  icon: string;
  color?: string;
  text?: string;
  description?: string;
  show: boolean | ((item: T) => boolean)
}

@Component
export default class ListWarnComponent<T> extends Vue {
  @Prop({ type: [Array, Object], required: true })
  private readonly warn!: ListWarn<T> | ListWarn<T>[]

  @Prop({ type: Object, required: true })
  private readonly item!: T

  get visibleWarn(): ListWarn<T> | null {
    if (Array.isArray(this.warn)) {
      for (const warn of this.warn) {
        const valid = this.validateWarn(warn)
        if (valid) {
          return warn
        }
      }
      return null
    } else {
      return this.validateWarn(this.warn) ?  this.warn : null
    }
  }

  validateWarn (warn: ListWarn<T>): boolean {
    switch (typeof warn.show) {
        case 'undefined':
        case 'object':
          return true
        case 'boolean':
          return warn.show
        case 'function':
          return warn.show(this.item)
        default:
          return false
      }
  }
}
